import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-02f36598")

_pushScopeId("data-v-02f36598")
const _hoisted_1 = {
  class: "p-grid p-m-0 p-p-2 p-fluid p-d-flex p-flex-column kn-height-full kn-overflow-y",
  "data-test": "drivers-form"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_DriversDetailCard = _resolveComponent("DriversDetailCard")
  const _component_UseMode = _resolveComponent("UseMode")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.title), 1)
      ]),
      end: _withId(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.handleSubmit
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          class: "p-button-text p-button-rounded p-button-plain",
          icon: "pi pi-times",
          onClick: _ctx.closeTemplate
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DriversDetailCard, {
        class: "p-mt-2",
        selectedDriver: _ctx.driver,
        types: _ctx.filteredTypes,
        onTouched: _ctx.setDirty
      }, null, 8, ["selectedDriver", "types", "onTouched"]),
      _createVNode(_component_UseMode, {
        class: " kn-flex-grow p-mt-2",
        propModes: _ctx.modes,
        roles: _ctx.roles,
        constraints: _ctx.constraints,
        layers: _ctx.layers,
        lovs: _ctx.lovs,
        selectionTypes: _ctx.filteredSelectionTypes,
        isDate: _ctx.isDateType,
        showMapDriver: _ctx.showMapDriver
      }, null, 8, ["propModes", "roles", "constraints", "layers", "lovs", "selectionTypes", "isDate", "showMapDriver"])
    ])
  ], 64))
})